import mime from 'mime/lite'

import { MediaType } from '../constants'
import { getFileExtension } from '@buffer-mono/shared-utils/uploads'
import { getMediaTypeFromMime } from './getMediaTypeFromMime'

export const getMimeAndExtensionFromName = (
  name = '',
): {
  mimeType?: string
  extension: string
  mediaType: MediaType
} => {
  if (!name) {
    return {
      mimeType: undefined,
      extension: '',
      mediaType: MediaType.unsupported,
    }
  }

  const mimeType = mime.getType(name) ?? undefined

  return {
    mimeType,
    extension: getFileExtension(name) ?? '',
    mediaType: getMediaTypeFromMime(mimeType),
  }
}
